<div *ngIf="!showAddExhibition && !updateExhibition && !showExhibition ">
  <div class="super-admin-exhibitions">
  <div class="d-flex justify-content-between align-items-center mt-0 exhibitions-table">
    <div class="pb-4">
      <h2 class="page-heading">Exhibitions</h2>
      <div *ngIf="chips?.length" class="d-flex flex-row align-items-center row-container-2 justify-content-between p-1 mb-3 exhibition-filters">
        <div >
          <span class="paragraph-medium">Filters applied: </span>
          <mat-chip class="chip-item" *ngFor="let chip of chips" (removed)="remove(chip)">
            {{ chip?.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </div>
        <div>
          <button class="mwe-button mwe-button--primary ps-3 pe-3 mx-3" (click)="clearAllFilters()">Clear all</button>
        </div>
      </div>
    </div>

    <div class="d-flex exhibition-management-header m-2 ">
      <mat-form-field appearance="outline" class="m-2 mr-1 search-bar">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Search" (input)="searchExhibition($event)" [value]="searchKeyword ? searchKeyword?.trim() : ''">
        <button *ngIf="searchKeyword?.trim()" matSuffix mat-icon-button aria-label="Clear" class="search-remove-container" (click)="clearSearch()">
          <mat-icon class="distributor-search-clear">close</mat-icon>
      </button>
      </mat-form-field>
      <button class="header-btn m-2 mr-1 export-btn" mat-raised-button (click)="exportExhibitionData()">
        <img src="assets/images/icons/Export.svg" alt=""> Export
      </button>
      <button class="header-btn m-2 mr-1 filter-btn" mat-raised-button (click)="openFilter()">
        <img src="assets/images/filter.svg" alt=""> Filter
      </button>
      <button class="header-btn m-2 add-exhibition-btn" mat-raised-button (click)="add()">
        <img src="assets/images/icons/vector.svg" alt="" > Add
      </button>
    </div>
  </div> 
  <div  class="summary-container">
    <div *ngFor="let object of objects" class="block">
        <div class="inside-block">
            <img [src]="object.image" alt="">
            <div class="detailed-summary">
                <h2 class="summary-text">{{ object.name }}</h2>
                <h1 class="summary-count">{{ object.count }}</h1>
               
            </div>
        </div>

    </div>
</div>

  <div *ngIf="chips?.length===0" class="summary-container">
    <div *ngFor="let object of oemsSummaryDataObjects" class="block">
        <div class="inside-block">
            <img [src]="object.image" alt="" class="exhibitions-image">
            <div class="detailed-summary">
                <h2 class="summary-text">{{ object.name }}</h2>
                <h1 class="summary-count">{{ object.count }}</h1>
            </div>
        </div>
    </div>
</div>
<div class="exhibitions">
  <app-mwe-table [columns]="columns" [showHeader]="true" [data]="Data" (selectedAction)="selectedAction($event)"
    [currentPageChanged]="page" [isDynemicPagination]="isPagination" (pageChanged)="onPageChanged($event)"
    (searchTerm)="onSearch($event)" [initialSearchValue]="searchKeyword" [showPagination]="showPagination" [dynamicPageSize]="pageSize" [totalEntries]="totalEntries">
  </app-mwe-table>
</div>
</div>
</div>

<!-- <h2 *ngIf="showNoRecordsFounds " class="no-records">No records found</h2> -->
<div *ngIf="showNoRecordsFounds && searchKeyword === ''" class="no-results">
  <img src="../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
  <div class="no-records-found"> No Records Found </div>
</div>

<div *ngIf="showAddExhibition">
  <app-addexhibition [oemId]="oemId" (backEvent)="close($event)" (selectedAction)="selectedAction($event)"
    [UpdateExhibibitionid]="UpdateExhibibitionid" [updateExhibition]="updateExhibition"></app-addexhibition>
</div>
<div *ngIf="updateExhibition">
  <app-addexhibition (backEvent)="close($event)" (selectedAction)="selectedAction($event)"
    [UpdateExhibibitionid]="UpdateExhibibitionid" [updateExhibition]="updateExhibition"></app-addexhibition>
</div>

<div *ngIf="showExhibition">
  <app-viewexhibition (backEvent)="close($event)" (selectedAction)="selectedAction($event)"
    [viewExhibitionId]="viewExhibitionId"></app-viewexhibition>
</div>